import React from 'react';
import {deleteMerchant, MerchantResponse} from "../../api/MerchantsApi";

type DeleteMerchantAccountProps = {
    showDeletePopup: boolean;
    selectedMerchant: MerchantResponse;
    handleCloseDelete: () => void;
    fetchMerchants: () => void;
    setSelectedMerchant: (merchant: MerchantResponse | null) => void;
};

const DeleteMerchantAccountComponent: React.FC<DeleteMerchantAccountProps> = ({
                                                                         showDeletePopup,
                                                                         selectedMerchant,
                                                                         handleCloseDelete,
                                                                         fetchMerchants,
                                                                         setSelectedMerchant
                                                                     }) => {

    const handleConfirmDelete = async (): Promise<void> => {
        try {
            await deleteMerchant(selectedMerchant.merchantId);
            setSelectedMerchant(null);
            fetchMerchants();
            handleCloseDelete();
        } catch (error) {
            alert('Failed to delete merchant. Please check your connection and try again.');
        }
    };

    if (!showDeletePopup) {
        return <></>;
    }

    return (
        <div id="delete-popup" className="popup">
            <div className="popup-content">
                <h2>Delete Merchant Account</h2>
                <button className="close-btn" onClick={handleCloseDelete}>X</button>
                <p>Are you sure you want to remove the following merchant account?</p>
                <p id="selected-merchant-name" className="merchant-name">Merchant: {selectedMerchant.merchantId}</p>
                <div className="popup-actions">
                    <button className="btn btn-primary" onClick={handleConfirmDelete}>Confirm</button>
                    <button className="btn btn-primary-light" onClick={handleCloseDelete}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default DeleteMerchantAccountComponent;